import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { Helpers } from '../helpers';

@Component({
  selector: 'app-bid-transporter-pickup-request',
  templateUrl: './bid-transporter-pickup-request.component.html',
  styleUrls: ['./bid-transporter-pickup-request.component.scss']
})
export class BidTransporterPickupRequestComponent implements OnInit {

  OrderData: any = {};
  IndentId: string = '';
  SumOfQty: any = 0;
  SumOfWeight: any = 0;
  TransporterList: any[] = [];
  TransporterId: any = '';
  BidTransporter: any = {};
  isBidOpen: boolean = true;
  whitelabelFlag: boolean = false;
  hostUrl: any = environment.apiUrl;
  IsShowMessage: boolean = false;
  Message = "";

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.IndentId = this._activatedRoute.snapshot.queryParams["IndentId"];
      this.TransporterId = this._activatedRoute.snapshot.queryParams["Transporter"];
      this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));

      if (this.IndentId == undefined || this.IndentId == null) {
        this.IndentId = this._activatedRoute.snapshot.queryParams["indentid"];
        this.TransporterId = this._activatedRoute.snapshot.queryParams["transporter"];
        this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelflag"));
      }
      if (this.IndentId !== undefined && this.IndentId !== null) {
        this.GetRequiredData();
      }
    });
  }

  GetRequiredData() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", this.IndentId, null).subscribe(
      (response) => {
        this.OrderData = response;
        this.CalcSum();
        this.GetTransporterRates();

        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(
          "An erro occured while fetching data",
          "ChargeType"
        );
        Helpers.setLoading(false);
      }
    );
  }

  CalcSum() {
    for (let i = 0; i < this.OrderData.ProductList.length; i++) {
      this.SumOfQty += (this.OrderData.ProductList[i].Qty ? this.OrderData.ProductList[i].Qty : 0);
      this.SumOfWeight += (this.OrderData.ProductList[i].weight ? this.OrderData.ProductList[i].weight : 0);
    }
  }

  GetTransporterRates() {
    Helpers.setLoading(true);
    this.BidTransporter.Amount = 0;
    this._appService.GetByTwoId("OrdersByVehicle", "GetPickupRateTransporter", this.IndentId, this.TransporterId).subscribe(
      async (res) => {
        var response = (await res) as any;
        this.BidTransporter.Amount = response[0].NetTotal;
        this.BidTransporter.Transporter = response[0].Transporter;
        this.BidTransporter.UserId = response[0].UserId;
        this.BidTransporter.BidSubmitted = response[0].BidSubmitted;
        this.BidTransporter.Status = response[0].Status;

        if (this.BidTransporter.BidSubmitted == 'Yes' && this.BidTransporter.Status == 'PENDING') {
          this.Message = "Link is expired!";
          this.IsShowMessage = true;
          document.getElementById("btnApprove").classList.add("disabled");
          document.getElementById("btnReject").classList.add("disabled");
        }
        if (this.BidTransporter.Status == 'APPROVED') {
          this.Message = "You have already approved this pickup request!";
          this.IsShowMessage = true;
          document.getElementById("btnApprove").classList.add("disabled");
          document.getElementById("btnReject").classList.add("disabled");
        }
        if (this.BidTransporter.Status == 'REJECTED') {
          this.Message = "You have already rejected this pickup request!";
          this.IsShowMessage = true;
          document.getElementById("btnApprove").classList.add("disabled");
          document.getElementById("btnReject").classList.add("disabled");
        }
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching data !",
          "error"
        );
        Helpers.setLoading(false);
      }
    );
  }

  AcceptBid() {
    if (this.BidTransporter.Amount == 0 || this.BidTransporter == null || this.BidTransporter == undefined) {
      this.toastr.error('Bid amount should be grater than zero !', 'Error');
      return;
    }

    this._appService
      .GetByFourId(
        "OrdersByVehicle",
        "CreareBookingFromOrderbyTransporterPickupReq",
        this.IndentId,
        this.OrderData.CompanyId,
        this.TransporterId,
        this.BidTransporter.UserId
      )
      .subscribe(
        (response) => {
          Helpers.setLoading(false);
          if (response == 100) {
            this.toastr.warning(
              'The reservation is already created!',
              "Alter"
            );
          }
          else {
            this.toastr.success(
              'Reserve created successfully',
              "Success"
            );
            this.UpdatePickupRequestBids('APPROVED');
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            'Error occurred while fetching data',
            "error"
          );
        }
      );
  }

  UpdatePickupRequestBids(status) {

    if (status == "REJECTED") {
      if (this.BidTransporter.Remark == "" || this.BidTransporter.Remark == null || this.BidTransporter.Remark == undefined) {
        this.toastr.error('Please enter remark !', 'Error');
        return;
      }
    }

    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.OrderId = this.IndentId;
    this.BidTransporter.Status = status;

    this._appService.Post("OrdersByVehicle", "UpdatePickupRequestBids", this.BidTransporter).subscribe(
      async (res) => {
        this.toastr.success('Data Successfully Submitted!', 'Ok');
        document.getElementById("btnApprove").classList.add("disabled");
        document.getElementById("btnReject").classList.add("disabled");
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching data !",
          "error"
        );
        Helpers.setLoading(false);
      }
    );
  }

}
